import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-payment-result-non-payment-image',
  templateUrl: './payment-result-non-payment-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentNonPaymentImageResultComponent {}
